import React from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { PricingCTA } from './components/PricingCTA';
import { UrgencyTimer } from './components/UrgencyTimer';
import { EmotionalHook } from './components/EmotionalHook';
import { FearCards } from './components/FearCards';
import { ComparisonTable } from './components/ComparisonTable';
import { ProductDescription } from './components/ProductDescription';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { PricingCards } from './components/PricingCards';
import { Guarantee } from './components/Guarantee';
import { EmotionalClose } from './components/EmotionalClose';
import { ValueStack } from './components/ValueStack';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyBottomBar } from './components/StickyBottomBar';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <StickyTopBar data-id="element-1" />
      <div className="relative bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/sAWjCMJnbbrr2ZVy4yf3sD/ChatGPT_Image_4_may_2026,_13_10_15.png')"
    }} data-id="element-2">
        <div className="absolute inset-0 bg-white/40" data-id="element-3"></div>
        <div className="relative z-10" data-id="element-4">
          <HeroSection data-id="element-5" />
          <PricingCTA data-id="element-6" />
        </div>
      </div>
      <UrgencyTimer data-id="element-7" />
      <EmotionalHook data-id="element-8" />
      <FearCards data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <ProductDescription data-id="element-11" />
      <BonusSection data-id="element-12" />
      <Testimonials data-id="element-13" />
      <PricingCards data-id="element-14" />
      <Guarantee data-id="element-15" />
      <EmotionalClose data-id="element-16" />
      <ValueStack data-id="element-17" />
      <FAQ data-id="element-18" />
      <Footer data-id="element-19" />
      <StickyBottomBar data-id="element-20" />
    </div>;
}